import Title from '@/components/Title';
import { UploadIcon } from '@/icons';
import { classes } from './utils';

export type EmptySelectorProps = {
  title: string;
  subtitle?: string;
};

export default function EmptySelector({ title, subtitle }: EmptySelectorProps) {
  return (
    <div className={classes.wrapper}>
      <div className={classes.iconWrapper}>
        <UploadIcon />
      </div>
      <Title className={classes.title} size="xs">
        {title}
      </Title>
      <div className={classes.subtitle}>{subtitle}</div>
    </div>
  );
}
